export default {
    name: 'SkipDown',
    dimensions: { width: 10, height: 10 },
    content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 10C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8L1 8C0.447715 8 5.40993e-07 8.44772 4.92711e-07 9C4.44428e-07 9.55228 0.447715 10 1 10L9 10Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.70711 0.292894C1.31658 -0.0976312 0.683418 -0.0976312 0.292894 0.292894C-0.0976312 0.683417 -0.0976312 1.31658 0.292894 1.70711L4.29289 5.70711C4.68342 6.09763 5.31658 6.09763 5.70711 5.70711L9.70711 1.70711C10.0976 1.31658 10.0976 0.683417 9.70711 0.292893C9.31658 -0.0976305 8.68342 -0.0976306 8.29289 0.292893L5 3.58579L1.70711 0.292894Z" fill="currentColor"/>
    `
};
